import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './img-filter.scss?inline';

export default class SotbitImgFilter extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        src: { type: String },
        size: { type: String, reflect: true },
    };

    constructor() {
        super();

        this.src = null;
        this.size = null;
    }

    render() {
        const iconSize = this.size === 's' ? 's' : 'm';

        return html` <div class="img-wrapper">
            ${this.src
                ? html`<img loading="lazy" src="${this.src}" />`
                : html` <sotbit-icon class="icon" size="${iconSize}" variant="simple" icon="no-photo-product"></sotbit-icon>`}
        </div>`;
    }
}
